import { render, staticRenderFns } from "./PageUserCommission.vue?vue&type=template&id=73bb4b60&scoped=true"
import script from "./PageUserCommission.vue?vue&type=script&lang=js"
export * from "./PageUserCommission.vue?vue&type=script&lang=js"
import style0 from "./PageUserCommission.vue?vue&type=style&index=0&id=73bb4b60&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73bb4b60",
  null
  
)

export default component.exports